<template>
  <router-link v-if="!link" :to="url">
    <div class="item">
      <div class="icon">
        <i :class="'w-fa far fa-'+icon"></i>
      </div>
      <h2 class="title">{{itemTitle}}</h2>
      <div v-if="amount" class="amount">{{amount}}</div>
    </div>
  </router-link>
  <a v-if="link" :href="url">
    <div class="item">
      <div class="icon">
        <i :class="'w-fa far fa-'+icon"></i>
      </div>
      <h2 class="title">{{itemTitle}}</h2>
      <div v-if="amount" class="amount">{{amount}}</div>
    </div>
  </a>
</template>

<script>

export default {
  props: ["itemTitle",'icon','url','amount','link'],
  name: "MainPageItem"
}
</script>

<style scoped>
router-link,a,RouterLink{
  display: inline-block;
  width: 100%;
}
.item {
  padding: 15px 5px;
  text-align: center;
  box-shadow: 0 0 5px 2px rgba(0,0,0,0.1);
  border-radius: 3px;
  overflow: hidden;
  margin: 2px 0;
  /*color: #ffa700;*/
  color: #0c2062;
  background: #fff;
}
.item .icon{
  text-align: center;
  margin-top: 8px;
}
.item .icon i{
  font-size: 30px;
}
.item .title{
  font-size: 13px;
  font-weight: 300;
  height: 50px;
  padding-top: 20px;
}
</style>